
import HomePage from '../pages/home.jsx';
import Beranda from '../pages/Beranda';
import AboutPage from '../pages/about.jsx';
import FormPage from '../pages/form.jsx';

import LeftPage1 from '../pages/left-page-1.jsx';
import LeftPage2 from '../pages/left-page-2.jsx';
import DynamicRoutePage from '../pages/dynamic-route.jsx';
import RequestAndLoad from '../pages/request-and-load.jsx';
import NotFoundPage from '../pages/404.jsx';
import CatalogPage from '../pages/catalog.jsx';
import SettingsPage from '../pages/settings.jsx';
import KategoriPage from '../pages/kategori';
import CariPage from '../pages/cari';
import DataPokokSekolah from '../pages/DataPokokSekolah';
import ProfilPendidikanSekolah from '../pages/ProfilPendidikanSekolah';
import RaporDapodik from '../pages/RaporDapodik/RaporDapodik';
import RaporDapodikProvinsi from '../pages/RaporDapodik/RaporDapodikProvinsi';
import RaporDapodikKabupaten from '../pages/RaporDapodik/RaporDapodikKabupaten';
import RaporDapodikSekolah from '../pages/RaporDapodik/RaporDapodikSekolah';
import RaporDapodikProfil from '../pages/RaporDapodik/RaporDapodikProfil';
import RaporDapodikPD from '../pages/RaporDapodik/RaporDapodikPD';
import RaporDapodikPTK from '../pages/RaporDapodik/RaporDapodikPTK';
import RekapData from '../pages/RekapData';
import SekolahRingkasan from '../pages/Sekolah/SekolahRingkasan';
import SekolahRingkasanSp from '../pages/Sekolah/SekolahRingkasanSp';
import SekolahWaktuPenyelenggaraan from '../pages/Sekolah/SekolahWaktuPenyelenggaraan';
import SekolahWaktuPenyelenggaraanSp from '../pages/Sekolah/SekolahWaktuPenyelenggaraanSp';
import PesertaDidikRingkasan from '../pages/PesertaDidik/PesertaDidikRingkasan';
import PesertaDidikRingkasanSp from '../pages/PesertaDidik/PesertaDidikRingkasanSp';
import PesertaDidikNISN from '../pages/PesertaDidik/PesertaDidikNISN';
import PesertaDidikNISNSp from '../pages/PesertaDidik/PesertaDidikNISNSp';
import PesertaDidikTingkat from '../pages/PesertaDidik/PesertaDidikTingkat';
import PesertaDidikTingkatSp from '../pages/PesertaDidik/PesertaDidikTingkatSp';
import PesertaDidikAgama from '../pages/PesertaDidik/PesertaDidikAgama';
import PesertaDidikAgamaSp from '../pages/PesertaDidik/PesertaDidikAgamaSp';
import SarprasRingkasan from '../pages/Sarpras/SarprasRingkasan';
import SarprasRingkasanSp from '../pages/Sarpras/SarprasRingkasanSp';
import SarprasTingkatKerusakan from '../pages/Sarpras/SarprasTingkatKerusakan';
import SarprasTingkatKerusakanSp from '../pages/Sarpras/SarprasTingkatKerusakanSp';
import login from '../pages/login';
import Indikator from '../pages/RaporDapodik/Indikator';
import ProfilPengguna from '../pages/ProfilPengguna';
import ProfilSekolah from '../pages/ProfilSekolah';
import Pengaturan from '../pages/Pengaturan';
import ManajemenPengguna from '../pages/ManajemenPengguna';
import VerifikasiPengguna from '../pages/VerifikasiPengguna';
import RaporDapodikPDIndividu from '../pages/RaporDapodik/RaporDapodikPDIndividu.jsx';
import RaporDapodikPTKIndividu from '../pages/RaporDapodik/RaporDapodikPTKIndividu.jsx';
import SekolahKurikulum from '../pages/Sekolah/SekolahKurikulum.jsx';
import SekolahKurikulumSp from '../pages/Sekolah/SekolahKurikulumSp.jsx';
import SekolahAkreditasi from '../pages/Sekolah/SekolahAkreditasi.jsx';
import GTKRingkasan from '../pages/GTK/GTKRingkasan.jsx';
import GTKRingkasanSp from '../pages/GTK/GTKRingkasanSp.jsx';
import GTKAgama from '../pages/GTK/GTKAgama.jsx';
import GTKAgamaSp from '../pages/GTK/GTKAgamaSp.jsx';
import GTKStatusKepegawaian from '../pages/GTK/GTKStatusKepegawaian.jsx';
import GTKStatusKepegawaianSp from '../pages/GTK/GTKStatusKepegawaianSp.jsx';
import GTKJenisKepegawaian from '../pages/GTK/GTKJenisKepegawaian.jsx';
import GTKJenisKepegawaianSp from '../pages/GTK/GTKJenisKepegawaianSp.jsx';
import GTKSatuanPendidikan from '../pages/GTK/GTKSatuanPendidikan.jsx';
import GTKSatuanPendidikanSp from '../pages/GTK/GTKSatuanPendidikanSp.jsx';
import GTKSertifikasi from '../pages/GTK/GTKSertifikasi.jsx';
import GTKSertifikasiSp from '../pages/GTK/GTKSertifikasiSp.jsx';
import Peta from '../pages/Peta.jsx';
import RaporDapodikBerkelanjutan from '../pages/RaporDapodik/RaporDapodikBerkelanjutan.jsx';
import RaporDapodikMutakhir from '../pages/RaporDapodik/RaporDapodikMutakhir.jsx';
import IndikatorBerkelanjutan from '../pages/RaporDapodik/IndikatorBerkelanjutan.jsx';
import IndikatorMutakhir from '../pages/RaporDapodik/IndikatorMutakhir.jsx';
import Transisi from '../pages/Transisi.jsx';
import RaporDapodikRingkasan from '../pages/RaporDapodik/RaporDapodikRingkasan.jsx';
import RaporSNP from '../pages/RaporSNP/RaporSNP.jsx';
import BerandaSPM from '../pages/BerandaSPM.jsx';
import formATS from '../pages/SPM/formATS.jsx';
import SPMUsiaSekolah from '../pages/SPM/SPMUsiaSekolah.jsx';
import formAnakMiskin from '../pages/SPM/formAnakMiskin.jsx';
import SPMLuarWilayah from '../pages/SPM/SPMLuarWilayah.jsx';
import SPMSatuanPendidikan from '../pages/SPM/SPMSatuanPendidikan.jsx';
import SPMPendidik from '../pages/SPM/SPMPendidik.jsx';
import SPMKepsek from '../pages/SPM/SPMKepsek.jsx';
import SPMTenagaPenunjang from '../pages/SPM/SPMTenagaPenunjang.jsx';
import verifikasiAts from '../pages/SPM/verifikasiAts.jsx';
import verifikasiPDMiskin from '../pages/SPM/verifikasiPDMiskin.jsx';
import formPenerimaSPM from '../pages/SPM/formPenerimaSPM.jsx';
import formRencanaPemenuhanSPM from '../pages/SPM/formRencanaPemenuhanSPM.jsx';
import editPenerimaSPM from '../pages/SPM/editPenerimaSPM.jsx';
import editRencanaPemenuhanSPM from '../pages/SPM/editRencanaPemenuhanSPM.jsx';
import tabel21 from '../pages/SPM/tabel21.jsx';
import tabel31 from '../pages/SPM/tabel31.jsx';
import form21 from '../pages/SPM/form21.jsx';
import form31 from '../pages/SPM/form31.jsx';
import tabel43 from '../pages/SPM/tabel43.jsx';
import tabel41 from '../pages/SPM/tabel41.jsx';
import tabel42 from '../pages/SPM/tabel42.jsx';
import form41 from '../pages/SPM/form41.jsx';
import form42 from '../pages/SPM/form42.jsx';
import ValidasiData from '../pages/ValidasiData/ValidasiData.jsx';
import formValidasiData from '../pages/ValidasiData/formValidasiData.jsx';
import hasilValidasi from '../pages/ValidasiData/hasilValidasi.jsx';
import rpp from '../pages/tmp/rpp.jsx';
import CustomQuery from '../pages/CustomQuery/CustomQuery.jsx';
import formIndexPendidikan from '../pages/IndexPendidikan/formIndexPendidikan.jsx';
import chartIndexPendidikan from '../pages/IndexPendidikan/chartIndexPendidikan.jsx';
import tambahIndexPendidikan from '../pages/IndexPendidikan/tambahIndexPendidikan.jsx';
import CustomQuerySekolah from '../pages/CustomQuery/CustomQuerySekolah.jsx';
import CustomQueryPesertaDidik from '../pages/CustomQuery/CustomQueryPesertaDidik.jsx';
import CustomQueryGTK from '../pages/CustomQuery/CustomQueryGTK.jsx';
import CustomQuerySarpras from '../pages/CustomQuery/CustomQuerySarpras.jsx';
import RombelRingkas from '../pages/RombonganBelajar/RombelRingkas.jsx';
import ProfilSekolahAnggota from '../pages/ProfilSekolahAnggota.jsx';
import ProfilSekolahAnggotaDetail from '../pages/ProfilSekolahAnggotaDetail.jsx';
import ProfilSekolahAnggotaDetailPD from '../pages/ProfilSekolahAnggotaDetailPD.jsx';
import PesertaDidikKIP from '../pages/PesertaDidik/PesertaDidikKIP.jsx';
import NPD from '../pages/NPD/index.jsx';
import DataIndividuptk from '../pages/DataIndividu/DataIndividuptk.jsx';
import DataIndividupd from '../pages/DataIndividu/DataIndividupd.jsx';
import ApkApm from '../pages/ApkApm/input/ApkApm.jsx';
import SekolahRekapSatuanPendidikan from '../pages/Sekolah/SekolahRekapSatuanPendidikan.jsx';
import RekapRombel from '../pages/RombonganBelajar/RekapRombel.jsx';
import SarprasRekapRuangKelas from '../pages/Sarpras/SarprasRekapRuangKelas.jsx';
import DaftarSatuanPendidikan from '../pages/Sekolah/DaftarSatuanPendidikan.jsx';
import DataApkApm from '../pages/ApkApm/data/ApkApm.jsx';
import DataApk from '../pages/ApkApm/data/Apk.jsx';
import DataApm from '../pages/ApkApm/data/Apm.jsx';
import DaftarRombel from '../pages/RombonganBelajar/DaftarRombel.jsx';
import DaftarRuang from '../pages/Sarpras/DaftarRuang.jsx';
import ProfilPendidikan from '../pages/ProfilePendidikan/data/ProfilPendidikan.jsx';
import PDBersekolahDiluarProvDIY from '../pages/PDBersekolahDiluarProvDIY/PDBersekolahDiluarProvDIY.jsx'
// import SekolahAkreditasiSp from '../pages/Sekolah/SekolahAkreditasiSp.jsx';

var routes = [
  {
    path: '/',
    component: (localStorage.getItem('kode_aplikasi') === 'SPM' ? BerandaSPM : Beranda),
  },
  {
    path: '/Pengaturan',
    component: Pengaturan,
  },
  {
    path: '/formATS',
    component: formATS,
  },
  {
    path: '/verifikasiAts/:nik',
    component: verifikasiAts,
  },
  {
    path: '/verifikasiPDMiskin/:nik',
    component: verifikasiPDMiskin,
  },
  {
    path: '/formAnakMiskin',
    component: formAnakMiskin,
  },
  {
    path: '/formPenerimaSPM',
    component: formPenerimaSPM,
  },
  {
    path: '/tabel21',
    component: tabel21,
  },
  {
    path: '/tabel31',
    component: tabel31,
  },
  {
    path: '/tabel43',
    component: tabel43,
  },
  {
    path: '/tabel41',
    component: tabel41,
  },
  {
    path: '/tabel42',
    component: tabel42,
  },
  {
    path: '/form21/',
    component: form21,
  },
  {
    path: '/form21/:perhitungan_kebutuhan_ats_id',
    component: form21,
  },
  {
    path: '/form31/',
    component: form31,
  },
  {
    path: '/form31/:rencana_pemenuhan_pelayanan_dasar_ats_id',
    component: form31,
  },
  {
    path: '/form41/',
    component: form41,
  },
  {
    path: '/form41/:realisasi_pencapaian_pemenuhan_pelayanan_dasar_ats_id',
    component: form41,
  },
  {
    path: '/form42/',
    component: form42,
  },
  {
    path: '/form42/:realisasi_pencapaian_pemenuhan_spm_id',
    component: form42,
  },
  {
    path: '/editPenerimaSPM/:pelayanan_dasar_id',
    component: editPenerimaSPM,
  },
  {
    path: '/editRencanaPemenuhanSPM/:kegiatan_id',
    component: editRencanaPemenuhanSPM,
  },
  {
    path: '/formRencanaPemenuhanSPM',
    component: formRencanaPemenuhanSPM,
  },
  {
    path: '/SPMSatuanPendidikan',
    component: SPMSatuanPendidikan,
  },
  {
    path: '/SPMPendidik',
    component: SPMPendidik,
  },
  {
    path: '/SPMKepsek',
    component: SPMKepsek,
  },
  {
    path: '/SPMTenagaPenunjang',
    component: SPMTenagaPenunjang,
  },
  {
    path: '/SPMUsiaSekolah',
    component: SPMUsiaSekolah,
  },
  {
    path: '/SPMLuarWilayah',
    component: SPMLuarWilayah,
  },
  {
    path: '/Peta',
    component: Peta,
  },
  {
    path: '/Peta/:keyword',
    component: Peta,
  },
  {
    path: '/Transisi/:url',
    component: Transisi,
  },
  {
    path: '/ManajemenPengguna',
    component: ManajemenPengguna,
  },
  {
    path: '/login',
    component: login,
  },
  {
    path: '/ProfilPendidikan',
    component: HomePage,
  },
  {
    path: '/ProfilSekolah/:sekolah_id',
    component: ProfilSekolah,
  },
  {
    path: '/ProfilSekolah/:sekolah_id/:param_tambahan',
    component: ProfilSekolah,
  },
  {
    path: '/ProfilSekolahAnggota/:sekolah_id/:type/:tingkat',
    component: ProfilSekolahAnggota,
  },
  {
    path: '/ProfilSekolahAnggotaDetail/:ptk_id',
    component: ProfilSekolahAnggotaDetail,
  },
  {
    path: '/ProfilSekolahAnggotaDetailPD/:peserta_didik_id',
    component: ProfilSekolahAnggotaDetailPD,
  },
  {
    path: '/ProfilPendidikanSekolah/:sekolah_id/',
    component: ProfilPendidikanSekolah,
  },
  {
    path: '/DataPokokSekolah/',
    component: DataPokokSekolah,
    keepAlive: true,
  },
  {
    path: '/DataPokokSekolah/:kata_kunci',
    component: DataPokokSekolah,
    keepAlive: true,
  },
  {
    path: '/RaporDapodik',
    component: RaporDapodik,
    // keepAlive: true,
  },
  {
    path: '/ValidasiData/:id_level_wilayah/:kode_wilayah',
    component: ValidasiData,
    // keepAlive: true,
  },
  {
    path: '/formValidasiData/:sekolah_id/:semester_id',
    component: formValidasiData,
    // keepAlive: true,
  },
  {
    path: '/hasilValidasi/:sekolah_id/:semester_id',
    component: hasilValidasi,
    // keepAlive: true,
  },
  {
    path: '/RekapData',
    component: RekapData,
    // keepAlive: true,
  },
  {
    path: '/formIndexPendidikan',
    component: formIndexPendidikan,
    // keepAlive: true,
  },
  {
    path: '/chartIndexPendidikan',
    component: chartIndexPendidikan,
    // keepAlive: true,
  },
  {
    path: '/tambahIndexPendidikan/:tipe',
    component: tambahIndexPendidikan,
    // keepAlive: true,
  },
  {
    path: '/tambahIndexPendidikan/:tipe/:kode_wilayah/:tahun',
    component: tambahIndexPendidikan,
    // keepAlive: true,
  },
  {
    path: '/CustomQuery/',
    component: CustomQuery
  },
  {
    path: '/CustomQueryPesertaDidik/',
    component: CustomQueryPesertaDidik
  },
  {
    path: '/CustomQueryGTK/',
    component: CustomQueryGTK
  },
  {
    path: '/CustomQuerySarpras/',
    component: CustomQuerySarpras
  },
  {
    path: '/CustomQuerySekolah/',
    component: CustomQuerySekolah,
    // keepAlive: true,
  },
  {
    path: '/rpp',
    component: rpp
  },
  {
    path: '/ProfilPengguna',
    component: ProfilPengguna,
    // keepAlive: true,
  },
  {
    path: '/ProfilPengguna/:pengguna_id',
    component: ProfilPengguna,
    // keepAlive: true,
  },
  {
    path: '/VerifikasiPengguna/:pengguna_id',
    component: VerifikasiPengguna,
    // keepAlive: true,
  },
  {
    path: '/RaporDapodikSekolah/:id_level_wilayah/:kode_wilayah',
    component: RaporDapodikSekolah,
    // keepAlive: true,
  },
  {
    path: '/RaporDapodikBerkelanjutan/:id_level_wilayah/:kode_wilayah',
    component: RaporDapodikBerkelanjutan,
    // keepAlive: true,
  },
  {
    path: '/RaporDapodikMutakhir/:id_level_wilayah/:kode_wilayah',
    component: RaporDapodikMutakhir,
    // keepAlive: true,
  },
  {
    path: '/RaporDapodik/Indikator',
    component: Indikator,
    keepAlive: true
  },
  {
    path: '/RaporDapodik/IndikatorBerkelanjutan',
    component: IndikatorBerkelanjutan,
    keepAlive: true
  },
  {
    path: '/RaporDapodik/IndikatorMutakhir',
    component: IndikatorMutakhir,
    keepAlive: true
  },
  {
    path: '/RaporDapodikPD/:sekolah_id',
    component: RaporDapodikPD,
    // keepAlive: true,
  },
  {
    path: '/RaporDapodikPDIndividu/:sekolah_id',
    component: RaporDapodikPDIndividu,
    // keepAlive: true,
  },
  {
    path: '/RaporDapodikPTK/:sekolah_id',
    component: RaporDapodikPTK,
    // keepAlive: true,
  },
  {
    path: '/RaporDapodikPTKIndividu/:sekolah_id',
    component: RaporDapodikPTKIndividu,
    // keepAlive: true,
  },
  {
    path: '/RaporDapodikWilayah/:kode_wilayah',
    component: RaporDapodik,
    // keepAlive: true,
  },
  {
    path: '/RaporDapodikProvinsi/:kode_wilayah',
    component: RaporDapodikProvinsi,
    // keepAlive: true,
  },
  {
    path: '/RaporDapodikKabupaten/:kode_wilayah',
    component: RaporDapodikKabupaten,
    // keepAlive: true,
  },
  {
    path: '/RaporDapodikProfil/:sekolah_id',
    component: RaporDapodikProfil,
    // keepAlive: true,
  },
  {
    path: '/RaporDapodikProfil/:sekolah_id/:param_tambahan',
    component: RaporDapodikProfil,
    // keepAlive: true,
  },
  {
    path: '/RaporDapodikRingkasan/:id_level_wilayah/:kode_wilayah',
    component: RaporDapodikRingkasan,
    // keepAlive: true,
  },
  {
    path: '/RaporSNP/:id_level_wilayah/:kode_wilayah',
    component: RaporSNP,
    // keepAlive: true,
  },
  {
    path: '/about/',
    component: AboutPage,
  },
  {
    path: '/form/',
    component: FormPage,
  },
  {
    path: '/catalog/',
    component: CatalogPage,
  },
  {
    path: '/kategori/',
    component: KategoriPage,
  },
  {
    path: '/cari/',
    component: CariPage,
  },
  {
    path: '/settings/',
    component: SettingsPage,
  },
  {
    path: '/left-page-1/',
    component: LeftPage1,
  },
  {
    path: '/left-page-2/',
    component: LeftPage2,
  },
  {
    path: '/dynamic-route/blog/:blogId/post/:postId/',
    component: DynamicRoutePage,
  },
  {
    path: '/request-and-load/user/:userId/',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = routeTo.params.userId;

      // Simulate Ajax Request
      setTimeout(function () {
        // We got user data from request
        var user = {
          firstName: 'Vladimir',
          lastName: 'Kharlampidi',
          about: 'Hello, i am creator of Framework7! Hope you like it!',
          links: [
            {
              title: 'Framework7 Website',
              url: 'http://framework7.io',
            },
            {
              title: 'Framework7 Forum',
              url: 'http://forum.framework7.io',
            },
          ]
        };
        // Hide Preloader
        app.preloader.hide();

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad,
          },
          {
            context: {
              user: user,
            }
          }
        );
      }, 1000);
    },
  },
  {
    path: '/Sekolah/Ringkasan',
    component: SekolahRingkasan
  },
  {
    path: '/Sekolah/Ringkasan/:id_level_wilayah/:kode_wilayah',
    component: SekolahRingkasan
  },
  {
    path: '/Sekolah/RingkasanSp/:id_level_wilayah/:kode_wilayah',
    component: SekolahRingkasanSp
  },
  {
    path: '/Sekolah/WaktuPenyelenggaraan',
    component: SekolahWaktuPenyelenggaraan
  },
  {
    path: '/Sekolah/WaktuPenyelenggaraan/:id_level_wilayah/:kode_wilayah',
    component: SekolahWaktuPenyelenggaraan
  },
  {
    path: '/Sekolah/WaktuPenyelenggaraanSp/:id_level_wilayah/:kode_wilayah',
    component: SekolahWaktuPenyelenggaraanSp
  },
  {
    path: '/Sekolah/RekapJumlahSatuanPendidikan/:kode_wilayah/:bentuk_pendidikan/:status',
    component: DaftarSatuanPendidikan
  },
  {
    path: '/Sekolah/RekapJumlahSatuanPendidikan',
    component: SekolahRekapSatuanPendidikan
  },
  {
    path: '/PesertaDidik/Ringkasan',
    component: PesertaDidikRingkasan
  },
  {
    path: '/PesertaDidik/Ringkasan/:id_level_wilayah/:kode_wilayah',
    component: PesertaDidikRingkasan
  },
  {
    path: '/PesertaDidik/RingkasanSp/:id_level_wilayah/:kode_wilayah',
    component: PesertaDidikRingkasanSp
  },
  {
    path: '/PesertaDidik/NISN',
    component: PesertaDidikNISN
  },
  {
    path: '/PesertaDidik/NISN/:id_level_wilayah/:kode_wilayah',
    component: PesertaDidikNISN
  },
  {
    path: '/PesertaDidik/NISNSp/:id_level_wilayah/:kode_wilayah',
    component: PesertaDidikNISNSp
  },
  {
    path: '/PesertaDidik/Tingkat',
    component: PesertaDidikTingkat
  },
  {
    path: '/PesertaDidik/Tingkat/:id_level_wilayah/:kode_wilayah',
    component: PesertaDidikTingkat
  },
  {
    path: '/PesertaDidik/TingkatSp/:id_level_wilayah/:kode_wilayah',
    component: PesertaDidikTingkatSp
  },
  {
    path: '/PesertaDidik/Agama',
    component: PesertaDidikAgama
  },
  {
    path: '/PesertaDidik/Agama/:id_level_wilayah/:kode_wilayah',
    component: PesertaDidikAgama
  },
  {
    path: '/PesertaDidik/AgamaSp/:id_level_wilayah/:kode_wilayah',
    component: PesertaDidikAgamaSp
  },
  {
    path: '/PesertaDidik/KIP/:id_level_wilayah/:kode_wilayah',
    component: PesertaDidikKIP
  },
  {
    path: '/PesertaDidik/KIP',
    component: PesertaDidikKIP
  },
  // {
  //   path: '/Sarpras/Ringkasan',
  //   component: SarprasRingkasan
  // },
  // {
  //   path: '/Sarpras/Ringkasan/:id_level_wilayah/:kode_wilayah',
  //   component: SarprasRingkasan
  // },
  // {
  //   path: '/Sarpras/RingkasanSp/:id_level_wilayah/:kode_wilayah',
  //   component: SarprasRingkasanSp
  // },
  {
    path: '/Sarpras/Ringkasan/:jenis',
    component: SarprasRingkasan
  },
  {
    path: '/Sarpras/Ringkasan/:id_level_wilayah/:kode_wilayah/:jenis',
    component: SarprasRingkasan
  },
  {
    path: '/Sarpras/RingkasanSp/:id_level_wilayah/:kode_wilayah/:jenis',
    component: SarprasRingkasanSp
  },
  {
    path: '/Sarpras/TingkatKerusakan/:jenis',
    component: SarprasTingkatKerusakan
  },
  {
    path: '/Sarpras/TingkatKerusakan/:id_level_wilayah/:kode_wilayah/:jenis',
    component: SarprasTingkatKerusakan
  },
  {
    path: '/Sarpras/TingkatKerusakanSp/:id_level_wilayah/:kode_wilayah/:jenis',
    component: SarprasTingkatKerusakanSp
  },
  {
    path: '/Sarpras/RekapRuangKelas/:kode_wilayah/:bentuk_pendidikan/:status',
    component: DaftarRuang
  },
  {
    path: '/Sarpras/RekapRuangKelas',
    component: SarprasRekapRuangKelas
  },
  {
    path: '/Sarpras',
    component:  RekapData
  },
  {
    path: '/Sekolah/Kurikulum',
    component: SekolahKurikulum
  },
  {
    path: '/Sekolah/Kurikulum/:id_level_wilayah/:kode_wilayah',
    component: SekolahKurikulum
  },
  {
    path: '/Sekolah/KurikulumSp/:id_level_wilayah/:kode_wilayah',
    component: SekolahKurikulumSp
  },
  {
    path: '/Sekolah/Akreditasi',
    component: SekolahAkreditasi
  },
  {
    path: '/Sekolah/Akreditasi/:id_level_wilayah/:kode_wilayah',
    component: SekolahAkreditasi
  },
  // {
  //   path: '/Sekolah/AkreditasiSp',
  //   component: SekolahAkreditasiSp
  // },
  // {
  //   path: '/Sekolah/AkreditasiSp/:id_level_wilayah/:kode_wilayah',
  //   component: SekolahAkreditasiSp
  // },
  {
    path: '/GTK/Ringkasan',
    component: GTKRingkasan
  },
  {
    path: '/GTK/Ringkasan/:id_level_wilayah/:kode_wilayah',
    component: GTKRingkasan
  },
  {
    path: '/GTK/RingkasanSp/:id_level_wilayah/:kode_wilayah',
    component: GTKRingkasanSp
  },
  {
    path: '/GTK/Agama',
    component: GTKAgama
  },
  {
    path: '/GTK/Agama/:id_level_wilayah/:kode_wilayah',
    component: GTKAgama
  },
  {
    path: '/GTK/AgamaSp/:id_level_wilayah/:kode_wilayah',
    component: GTKAgamaSp
  },
  {
    path: '/GTK/StatusKepegawaian',
    component: GTKStatusKepegawaian
  },
  {
    path: '/GTK/StatusKepegawaian/:id_level_wilayah/:kode_wilayah',
    component: GTKStatusKepegawaian
  },
  {
    path: '/GTK/StatusKepegawaianSp',
    component: GTKStatusKepegawaianSp
  },
  {
    path: '/GTK/StatusKepegawaianSp/:id_level_wilayah/:kode_wilayah',
    component: GTKStatusKepegawaianSp
  },
  {
    path: '/GTK/JenisKepegawain',
    component: GTKJenisKepegawaian
  },
  {
    path: '/GTK/JenisKepegawain/:id_level_wilayah/:kode_wilayah',
    component: GTKJenisKepegawaian
  },
  {
    path: '/GTK/JenisKepegawainSp/:id_level_wilayah/:kode_wilayah',
    component: GTKJenisKepegawaianSp
  },
  {
    path: '/GTK/SatuanPendidikan',
    component: GTKSatuanPendidikan
  },
  {
    path: '/GTK/SatuanPendidikanSp/:id_level_wilayah/:kode_wilayah',
    component: GTKSatuanPendidikanSp
  },
  {
    path: '/GTK/Sertifikasi',
    component: GTKSertifikasi
  },
  {
    path: '/GTK/SertifikasiSp/:id_level_wilayah/:kode_wilayah',
    component: GTKSertifikasiSp
  },
  {
    path: '/Rombel/Ringkasan/umum',
    component: RombelRingkas
  },
  {
    path: '/Rombel/Ringkasan/umum/:id_level_wilayah/:kode_wilayah',
    component: RombelRingkas
  },
  {
    path: '/Rombel/RekapRombonganBelajar/:kode_wilayah/:bentuk_pendidikan/:status',
    component: DaftarRombel
  },
  {
    path: '/Rombel/RekapRombonganBelajar',
    component: RekapRombel
  },
  {
    path: '/NPD',
    component: NPD
  },
  {
    path: '/data-individu/ptk',
    component: DataIndividuptk
  },
  {
    path: '/data-individu/pd',
    component: DataIndividupd
  },
  {
    path: '/apk-apm/input-data/:type',
    component: ApkApm
  },
  {
    path: '/apk-apm/paud-ra',
    component: DataApkApm
  },
  {
    path: '/apk-apm/paud-only',
    component: DataApkApm
  },
  {
    path: '/apk-apm/sd-mi-paketa',
    component: DataApkApm
  },
  {
    path: '/apk-apm/smp-mts-paketb',
    component: DataApkApm
  },
  {
    path: '/apk-apm/sma-smk-paketc',
    component: DataApkApm
  },
  {
    path: '/apk-apm/slb',
    component: DataApkApm
  },
  {
    path: '/apk/paud-ra',
    component: DataApk
  },
  {
    path: '/apk/paud-only',
    component: DataApk
  },
  {
    path: '/apk/sd-mi-paketa',
    component: DataApk
  },
  {
    path: '/apk/smp-mts-paketb',
    component: DataApk
  },
  {
    path: '/apk/sma-smk-paketc',
    component: DataApk
  },
  {
    path: '/apk/slb',
    component: DataApk
  },
  {
    path: '/apm/paud-ra',
    component: DataApm
  },
  {
    path: '/apm/paud-only',
    component: DataApm
  },
  {
    path: '/apm/sd-mi-paketa',
    component: DataApm
  },
  {
    path: '/apm/smp-mts-paketb',
    component: DataApm
  },
  {
    path: '/apm/sma-smk-paketc',
    component: DataApm
  },
  {
    path: '/apm/slb',
    component: DataApm
  },
  {
    path: '/profil-pendidikan/:module',
    component: ProfilPendidikan
  },
  {
    path: '/peserta-didik-bersekolah-di-luar-prov-diy',
    component: PDBersekolahDiluarProvDIY
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;
